import { IPostedShiftsData, PharmacistLegendVariant, TimeFormat } from '@pharmaplan/common';
import { DynamicTableCell, ScreenTypes } from '../../../../helpers/Constants';
import strings from '../../../../localization';
import { store } from '../../../../store';
import { getDayMonthDateYear, getHourMinute } from '../../../Reports/helpers';
import { renderScreen, setOpen } from '../../../../actions/drawerActions';
import { resetDialog } from '../../../../reducers/dialogReducer';

export const headers = () =>
  [
    { key: '0', label: strings.time },
    { key: '1', label: strings.date },
    { key: '2', label: strings.action },
  ];

export const rowsMapper = (
  data: Array<IPostedShiftsData>,
  timeFormat: TimeFormat,
  dispatch: typeof store.dispatch,
  buttonConfig: (id: string) => void,
) =>
  data?.map((item) =>
    ({
      key: item.workShiftId,
      data: [
        {
          key: `${item.workShiftId}-2`,
          value: {
            label: getDayMonthDateYear(item.selectedDate),
            handlePress: () => {
              dispatch(setOpen(true));
              dispatch(resetDialog());
              dispatch(
                renderScreen({
                  screenNumber: 1,
                  screenType: ScreenTypes.serviceWorkshiftDetails,
                  eventIds: [item.workShiftId],
                  type: PharmacistLegendVariant.workshift,
                }),
              );
            },
          },
          type: DynamicTableCell.customLink,
        },
        {
          key: `${item.workShiftId}-3`,
          value: `${getHourMinute(item.startDate, timeFormat)} - ${getHourMinute(
            item.endDate,
            timeFormat,
          )}`,
          type: DynamicTableCell.text,
        },
        {
          key: `${item.workShiftId}-5`,
          value: buttonConfig(item.workShiftId),
          show: true,
          type: DynamicTableCell.button,
        },
      ],
    }));
